import { componentSizes } from '@/theme/componentSizes';
import { s, tableTokens } from '../../theme/tokens';
import { Box } from './Box';
import { Skeleton } from './Skeleton';
import type { ReactNode } from 'react';

export const DataGridEmptyState = ({
  title,
  body,
  action,
}: {
  title: string;
  body?: string;
  action?: ReactNode;
}): JSX.Element => (
  <Box
    sx={{
      padding: s('xl'),
      textAlign: 'center',
      color: 'text.secondary',
      display: 'flex',
      flexDirection: 'column',
      gap: s('sm'),
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: componentSizes.dataGrid.stateMinHeight,
      height: '100%',
      width: '100%',
    }}
  >
    <Box sx={{ fontWeight: 600 }}>{title}</Box>
    {body ? <Box>{body}</Box> : null}
    {action ? <Box>{action}</Box> : null}
  </Box>
);

export const DataGridLoadingState = ({
  label = 'Loading',
  rowCount = 6,
}: {
  label?: string;
  rowCount?: number;
}): JSX.Element => (
  <Box
    aria-label={`${label}...`}
    sx={{
      paddingY: s('lg'),
      paddingX: s('xl'),
      display: 'grid',
      gap: s('sm'),
      minHeight: componentSizes.dataGrid.stateMinHeight,
      alignContent: 'center',
    }}
  >
    {Array.from({ length: rowCount }).map((_value, index) => (
      <Box
        key={`grid-loading-row-${index}`}
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: s(tableTokens.cellPadding.y),
        }}
      >
        <Skeleton height={componentSizes.dataGrid.skeletonHeight} width="100%" variant="text" />
      </Box>
    ))}
  </Box>
);
